module.exports = __webpack_public_path__ + "static/media/ecosentino-white.2881407b.svg";